<template>
  <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 20.6702L5 13.6702L12 6.67017" stroke="#386280" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 13.6702L5 13.6702" stroke="#386280" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>